import styled from 'styled-components';
import { RequireModal } from 'ui-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledModal = styled(RequireModal)`
  width: 440px;
`;
